(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_reviews"] && !Shopify.designMode) return;
  try {
    
	$('.review-slider').slick({
	  infinite: true,
	  slidesToShow: 5,
	  dots: true,
	  arrows: false,
	  centerMode: true,
	  adaptiveHeight:true,
	  centerPadding: '0px',
	  cssEase: 'linear',
	   responsive: [
		{
		  breakpoint: 960,
		  settings: {
			slidesToShow: 3
		  }
		},
		{
		  breakpoint: 768,
		  settings: {
			slidesToShow: 1
		  }
		}
	  ]
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var button = event.target.closest('.ttl-fp__nav');
  if (!button) return;
  var root = button.closest('.ttl-fp--slider');
  if (!root) return;
  var grid = root.querySelector('.ttl-fp__grid--scroll');
  if (!grid) return;
  var card = grid.querySelector('.ttl-fp-card');
  if (!card) return;
  var styles = window.getComputedStyle(grid);
  var gap = parseFloat(styles.columnGap || styles.gap) || 24;
  var distance = card.getBoundingClientRect().width + gap;
  if (button.classList.contains('ttl-fp__nav--prev')) {
    distance = -distance;
  }
  grid.scrollBy({ left: distance, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
document.addEventListener('click', function (event) {
  var button = event.target.closest('.ttl-fp__nav');
  if (!button) return;
  var root = button.closest('.ttl-fp--slider');
  if (!root) return;
  var grid = root.querySelector('.ttl-fp__grid--scroll');
  if (!grid) return;
  var card = grid.querySelector('.ttl-fp-card');
  if (!card) return;
  var styles = window.getComputedStyle(grid);
  var gap = parseFloat(styles.columnGap || styles.gap) || 24;
  var distance = card.getBoundingClientRect().width + gap;
  if (button.classList.contains('ttl-fp__nav--prev')) {
    distance = -distance;
  }
  grid.scrollBy({ left: distance, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();
})();
